import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getUnixTime, parseJSON } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';

import './TillOverview.scss';
import { formatAmountToFixed } from 'src/utils/utils';
import TransactionContext from '../../context/Transactions.context';
import _ from 'lodash';
import { RootState } from '../../../../../configs/store';

interface TillOverviewProps {
  userName: string,
  isEndOfShift?: boolean,
  loginTime: number
}

function TillOverview({ userName, isEndOfShift=false, loginTime }: TillOverviewProps) {
  const { t } = useTranslation();
  const tillCode = localStorage.getItem('footerTill');
  const [overview, setOverview] = useState(null);
  const { shouldReload, tillHistory } = useSelector((state: RootState) => state.peripherals);
  const { dates, filterType } = useContext(TransactionContext);

  const dispatch = useDispatch();

  const getOverview = async () => {
    const response = await dispatch.peripherals.getOverview({
      createdAtFrom: !isEndOfShift ? dates.startDate : getUnixTime(parseJSON(loginTime * 1000)),
      ...(!isEndOfShift && { transactionType: filterType })
    });
    if (response){
      setOverview(response[0]);
    }
  };

  useEffect(() => {
    if (shouldReload || !overview){
      setTimeout(() => {
        getOverview();
      }, 1000);
      dispatch.peripherals.changeReload(false);
    }
  }, [dates, shouldReload]);

  if (tillHistory || localStorage.getItem('fakeTill') === 'true'){
    return (
      <div className={
        classNames({
          'till-overview': true,
          'till-overview--sticky': !isEndOfShift,
          'till-overview--scrollable': isEndOfShift
        })
      }
      >
        <h4 className="till-overview__title">{ t('transactions.tillOverview') }</h4>
        <div className="till-overview__user-info">
          <span className="till-overview__sub-title">{ t('transactions.userId') }</span>
          <span className="till-overview__sub-title">{ t('transactions.userName') }</span>
          <span className="till-overview__sub-title">{ t('transactions.tillCode') }</span>
          <span className="till-overview__user-details"></span>
          <span className="till-overview__user-details">{ userName }</span>
          <span className="till-overview__user-details">{ tillCode }</span>
        </div>
        {
          overview && <div className="till-overview__totals">
            <h5 className="till-overview__sub-title till-overview__sub-title--underline">{ t('transactions.totals') }</h5>
            <div className="till-overview__totals-container">
              <span className="till-overview__totals-details">{ t('transactions.openingBalance') }</span>
              <span className="till-overview__totals-details">{
                formatAmountToFixed(overview.openingBalance, overview.type.divisor, true) ||
           '0.00'
              } </span>
              <span className="till-overview__totals-details">{ t('transactions.totalDebits') }</span>
              <span className="till-overview__totals-details">{
                formatAmountToFixed(overview.totalDebits, overview.type.divisor, true)
           || '0.00'
              } </span>
              <span className="till-overview__totals-details">{ t('transactions.totalCredits') }</span>
              <span className="till-overview__totals-details">{
                formatAmountToFixed(overview.totalCredits, overview.type.divisor, true)
          || '0.00'
              }</span>
              <span className="till-overview__totals-details">{ t('transactions.closingBalance') }</span>
              <span className="till-overview__totals-details">{
                formatAmountToFixed(overview?.closingBalance, overview?.type.divisor, true)
           || '0.00'
              } </span>
            </div>
          </div>
        }
        <div className="till-overview__totals">
          <h5 className="till-overview__sub-title till-overview__sub-title--underline">{ t('transactions.transactionAnalysis') }</h5>
          <div className="till-overview__totals-container">
            {
              overview && overview.transactionsTypes &&
            _.map(overview.transactionsTypes, (transaction) => {
              return (
                <>
                  <span className="till-overview__totals-details"> { transaction.name } </span>
                  <span className="till-overview__totals-details">
                    { formatAmountToFixed(transaction?.totalAmount, overview?.type.divisor, true) }
                  </span>
                </>
              );

            })
            }
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default TillOverview;
